import React, { useEffect, useRef } from 'react';
import './GuideCard.css';

// Native details remains keyboard-accessible without a custom disclosure widget.
export default function GuideCard({ id, title, description, children, language = 'de' }) {
  const ref = useRef(null);
  useEffect(() => {
    const reveal = () => {
      let anchor;
      try { anchor = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
      const target = document.getElementById(anchor);
      if (!target || !ref.current?.contains(target)) return;
      ref.current.open = true;
      target.scrollIntoView({ block: 'start' });
    };
    const click = event => {
      const link = event.target.closest?.('a[href]');
      if (!link) return;
      const url = new URL(link.href, window.location.href);
      if (url.origin === window.location.origin && url.pathname === window.location.pathname && url.search === window.location.search && url.hash === window.location.hash) reveal();
    };
    reveal();
    window.addEventListener('hashchange', reveal);
    document.addEventListener('click', click);
    return () => { window.removeEventListener('hashchange', reveal); document.removeEventListener('click', click); };
  }, []);
  return <details ref={ref} id={id} className="guide-card">
    <summary><div><h3>{title}</h3><p>{description}</p><span className="guide-card__hint">{language === 'en' ? 'Open / close guide' : 'Anleitung öffnen / schließen'}</span></div><span className="guide-card__chevron" aria-hidden="true">⌄</span></summary>
    <div className="guide-card__body">{children}</div>
  </details>;
}
